import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import moment from "moment";
import axios from "axios";

import {
  Row,
  Col,
  Card,
  Button,
  Space,
  message,
  Empty,
  Spin,
  Typography,
  Divider,
  Table,
  Modal,
  Statistic,
} from "antd";
import { HeartOutlined, LineChartOutlined } from "@ant-design/icons";

import {
  ACTION,
  CANCEL_REQUEST,
  DATE_TIME_FORMAT,
  FILE_TYPE,
} from "constants/index";

import emptyImg from "../../assets/img/empty.svg";
import BidModal from "./BidModal";
import BidderModal from "./BidderModal";

import AuthorizedFunction from "config/AuthorizedFunction";
import GeneralHelper from "helper/general.helper";
const { Title } = Typography;
const { Countdown } = Statistic;

const DataTable = ({ data, onUpdate }) => {
  const user = useSelector((state) => state.authReducer.user);
  const [openBidderModal, setOpenBidderModal] = useState(false);
  const [openBidModal, setOpenBidModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [tableData, setTableData] = useState([]);
  const dispatch = useDispatch();

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      sorter: (a, b) => a.name.toString().localeCompare(b.name.toString()),
      // defaultSortOrder: "ascend",
    },
    {
      title: "Current Price",
      dataIndex: "current_price",
      render: (data) => <>{`$${data}`}</>,
      sorter: (a, b) => a.current_price - b.current_price,
    },
    {
      title: "Duration",
      dataIndex: "expired_date",
      render: (data) => (
        <>
          <Countdown
            title=""
            value={data}
            onFinish={"Expired"}
            format="D d H:m:ss"
          />
        </>
      ),
      sorter: (a, b) => a.expired_date - b.expired_date,
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) =>
        moment(record.expired_date) >= Date.now() &&
        record.user_id != user.id &&
        record.bidder_id != user.id ? (
          <Space size="middle">
            <Button
              type="primary"
              icon={<HeartOutlined />}
              onClick={() => showBidModal(record)}
            >
              Bid
            </Button>
            <Button
              type="default"
              icon={<LineChartOutlined />}
              onClick={() => showBidderModal(record)}
            >
              View
            </Button>
          </Space>
        ) : (
          <Space size="middle">
            <Button
              type="default"
              icon={<LineChartOutlined />}
              onClick={() => showBidderModal(record)}
            >
              View
            </Button>
          </Space>
        ),
    },
  ];

  const onFinish = (id) => {
    console.log(id, "finished!");
  };

  const showBidModal = (item) => {
    setSelectedItem(item);
    setOpenBidModal(true);
  };

  const showBidderModal = (item) => {
    setSelectedItem(item);
    setOpenBidderModal(true);
  };

  useEffect(() => {
    if (AuthorizedFunction(["user"])) {
      const CancelToken = axios.CancelToken;
      const source = CancelToken.source();

      if (data) {
        setTableData(data);
      }

      return () => {
        source.cancel(CANCEL_REQUEST);
      };
    }
  }, [data]);

  return !isLoading ? (
    <Space size={16} direction="vertical" style={{ width: "100%" }}>
      <Card>
        <Table
          columns={columns}
          dataSource={tableData}
          pagination={{ pageSize: 10 }}
        />
      </Card>
      <BidModal
        open={openBidModal}
        onClose={setOpenBidModal}
        data={selectedItem}
        onUpdate={onUpdate}
      />
      <BidderModal
        open={openBidderModal}
        onClose={setOpenBidderModal}
        data={selectedItem}
      />
    </Space>
  ) : (
    <Empty
      image={emptyImg}
      imageStyle={{
        height: 60,
      }}
      description={<span>Loading..</span>}
    >
      <Spin />
    </Empty>
  );
};
export default DataTable;
